import { createColumnHelper } from "@tanstack/react-table";
import { PropertiesProps } from "./recent-properties.interface";
import AvatarC from "../common/avatar";
import styles from "../dashboard-properties/recent-properties.module.scss";
import { Skeleton } from "primereact/skeleton";
import {
  countDaysFromDate,
  formatCurrency,
  StatusObjectColorFilter
} from "../../utils/utils";
import Like from "../common/like";
import { Tag } from "primereact/tag";
import PriceDropTag from "../common/pricedrop-tag";

const useColumns = (type: string) => {
  const columnHelper = createColumnHelper<PropertiesProps>();
  const recentPropertyColumns: any = [
    columnHelper.accessor("posterImage", {
      id: "Image",
      header: "",
      cell: (props: any) => {
        return (
          <>
            {props ? (
              <div className={styles.imgWrap}>
                  <div className={styles.propertyImgWrap}>
                  <img
                    src={props.getValue() ?? "/images/default-property.jpg"}
                    alt="Image"
                    width="20%"
                    className={styles.propertyImg}
                  />
                  {type === "agent" && (
                    <div className={styles.daysCount}>
                      <Tag
                        value={
                          countDaysFromDate(props.row.original?.createdAt) > 1
                            ? `${countDaysFromDate(
                                props.row.original?.createdAt
                              )} Days ago`
                            : `${countDaysFromDate(
                                props.row.original?.createdAt
                              )} Day ago`
                        }
                        style={{
                          background: "#0000008a",
                          color: "#ffffff"
                        }}
                        className={styles.tagClass}
                      />
                    </div>
                  )}
                </div>
                <div className={styles.address}>
                  {/* {props.row.original.address} */}
                  <div>{props.row.original.address.split(",")[0]}</div>
                  {/* {`${props.row.original.address1},${props.row.original.address2}`} */}
                  {props.row.original.address.split(",").length > 1 && (
                    <div className={styles.text}>
                      {props.row.original.address.split(",")[1]},
                      {props.row.original.address.split(",")[2]}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <Skeleton
                width="18.625rem"
                height="3.875rem"
                className={styles.address}
              />
            )}
          </>
        );
      }
    }),
    columnHelper.accessor("askingPrice", {
      id: "askingPrice",
      header: "PRICE",
      cell: (props: any) => (
        <>
          <span className={`${styles.highestOffer} ${styles.textAlign}`}>
            {formatCurrency(props.getValue(), "USD", "en-US", 0, 0)}
          </span>
          <PriceDropTag
            type={type}
            priceDrop={props.row.original.priceDrop}
            priceDropDate={props.row.original.priceDropDate}
          />
        </>
      )
    }),
    // columnHelper.accessor('offers', {
    //   id: 'offers',
    //   header: 'OFFERS',
    //   cell: (props: any) => (
    //     <span className={styles.highestOffer}>
    //       {formatNumber(props.getValue(), 0, 0)}
    //     </span>
    //   ),
    // }),
    columnHelper.accessor("address", {
      id: "location",
      header: "LOCATION",
      cell: (props: any) => (
        <span
          className={styles.highestOffer}
        >{`${props.row.original.city}, ${props.row.original.state}`}</span>
      )
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: "STATUS",
      cell: (props: any) => (
        <span
          className={styles.status}
          style={{
            verticalAlign: "top"
          }}
        >
          {props.getValue() && (
            <span
              className={`${styles.circle}`}
              style={{
                backgroundColor:
                  StatusObjectColorFilter(props.getValue())?.bgColor ||
                  "#0000008a"
              }}
            />
          )}
          {props.getValue()}
        </span>
      )
    }),
    columnHelper.accessor("agentName", {
      id: "agent",
      header: type === "agent" ? "AGENT" : "",
      cell: (props: any) => {
        return (
          <>
            {type === "agent" && (
              <div className={styles.agent}>
                {/* {props.row.original.agentPhoto && ( */}
                <AvatarC
                  // image={props.row.original.agentPhoto}
                  label={`${props.row.original.acquisitionAgent1?.name?.slice(
                    0,
                    1
                  )}${props.row.original.acquisitionAgent1?.name
                    ?.split(" ")[1]
                    ?.slice(0, 1)}`}
                  size="large"
                  shape="circle"
                />
                {/* )} */}
                {(props.row.original.acquisitionAgent1?.name?.split(" ")[0] ||
                  props.row.original.acquisitionAgent1?.name?.split(
                    " "
                  )[1]) && (
                  <span className={styles.name}>
                    {props.row.original.acquisitionAgent1?.name?.split(" ")[0] +
                      " " +
                      props.row.original.acquisitionAgent1?.name?.split(" ")[1]}
                  </span>
                )}
              </div>
            )}
          </>
        );
      }
    }),
    columnHelper.accessor("favCount", {
      id: "like",
      header: "",
      cell: (props: any) => {
        const currentPageData = props.table.getRowModel().rows;
        return (
          <span className={props.getValue()}>
            <Like
              loginType={type}
              propertyId={props.row.original?.id}
              favCount={props.row.original?.favCount}
              width={25}
              isSavedProperty={true}
              currentPageItemCount={currentPageData.length}
              objPropertyDetails={props.row.original}
            />
          </span>
        );
      }
    })
  ];
  return { recentPropertyColumns };
};

export default useColumns;
